// extracted by mini-css-extract-plugin
export var text = "_4m-0";